import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { toast } from '../../components/ui/Toast';
import { useTranslation } from '../../i18n/LanguageContext';
import { IconDownload, IconAlertTriangle, IconDatabase } from '@tabler/icons-react';

export default function Data() {
  const { t } = useTranslation();
  const { org } = useAuth();

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 600, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <IconDatabase size={20} color="var(--color-text-secondary)" stroke={1.5} />
          <h1 style={{ fontSize: 22, fontWeight: 400 }}>{t('set.data_retention')}</h1>
        </div>

        <Card style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 10 }}>{t('set.export_title')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', lineHeight: 1.6, marginBottom: 14 }}>
            {t('set.export_desc')}
          </div>
          <Button variant="secondary" icon={<IconDownload size={14} stroke={1.5} />} onClick={() => toast.info(t('set.export_coming_soon'))}>
            {t('set.export_btn')}
          </Button>
        </Card>

        <Card style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 10 }}>{t('set.retention_title')}</div>
          <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', lineHeight: 1.6 }}>
            {t('set.retention_desc')}
          </div>
        </Card>

        <Card style={{ border: '0.5px solid var(--color-danger)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <IconAlertTriangle size={16} color="var(--color-danger)" stroke={1.5} />
            <div style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-danger)' }}>{t('set.danger_zone')}</div>
          </div>
          <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', lineHeight: 1.6, marginBottom: 14 }}>
            {t('set.danger_desc')}
          </div>
          <Button variant="danger" onClick={() => toast.error(t('set.delete_org_toast'))}>
            {t('set.delete_org')}
          </Button>
        </Card>
      </div>
    </Layout>
  );
}